import * as types from "../actions/actionTypes"
import { combineReducers } from "redux";
import initialState from './initialState';
import auth from './authReducer';
import orderList from './orderReducer';
import makeOrder from './makeOrderReducer';
import transactions from './transactionReducer';
import register from './registerReducer';
import equipments from './equipmentReducer';
import company from './companyReducer';
import employees from './employeesReducer';
import payOutList from './payOutReducer';
import promocode from './promocodeReducer';
import news from './newsReducer';
import products from './buyReducer';
import cameras from './cameraRequirementReducer';
import objectTypes from './orderObjectTypeReducer';
import methodTypes from './methodTypeReducer';
import measures from './measureReducer';
import locations from './locationsReducer';
import globalErrors from './globalErrorReducer';

const data = (state = initialState.data, action) => {
  switch (action.type) {
    case types.RECEIVE_INFO:
      return {...state, [action.queryName]:action.data}
    default:
      return state;
  }
};

const isLoading = (state = initialState.isLoading, action) => {
  switch (action.type) {
    case types.REQUEST_INFO:
      return true;
    case types.RECEIVE_INFO:
      return false;
    default:
      return state;
  }
}
const errorMessages = (state={}, action) =>{
  switch (action.type) {
    case types.ERROR_MESSAGE:
      return {...state, ...action.message};
    case types.RESET_ERRORS:
      return {};
    default:
      return state;
  }

}
// this function will change
const session = (state = initialState.session, action) => {
  let currBalance, newBalance;
  switch (action.type) {
    case types.CURRENT_USER_REQUEST:
      return {
        isLoggedIn: action.update ? state.isLoggedIn : false,
        isUpdating: action.update ? true : false,
        isFetching: action.update ? state.isFetching : true,
        token: action.token,
        currentUser: action.update ? state.currentUser : {}
      }
    case types.CURRENT_USER_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        isFetching: false,
        errorMessage: '',
        isUpdating: false,
        currentUser: {...state.currentUser, ...action.currentUser}
      }
    case types.CURRENT_USER_FAILED:
      return {
        isLoggedIn: false,
        isFetching: false,
        currentUser: {},
        isUpdating: false,
        errorMessage: action.message,
        errorStatus: action.errorStatus,
      }

    case types.UPDATE_USER_DATA_REQUEST:
      return Object.assign({}, state, {
        isUpdating: true,
      })
    case types.UPDATE_USER_DATA_SUCCESS:
      return Object.assign({}, state, {
        isUpdating: false,
        currentUser: {...state.currentUser, ...action.currentUser}
      })
    case types.UPDATE_USER_DATA_FAILED:
      return Object.assign({}, state, {
        isUpdating: false,
        errorMessage: action.message
      })

    case types.LOGOUT_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })
    case types.LOGOUT_RECEIVE:
      return initialState.session
    case types.LOGOUT_FAILURE:
      return Object.assign({}, state, {
        errorMessage: action.payload
      })

    case types.WRITE_OFF_MONEY_USER:
      currBalance = state.currentUser.balance_customer;
      newBalance = (parseFloat(currBalance) - parseFloat(action.data.price));

      return Object.assign({}, state, {
        currentUser: {
          ...state.currentUser,
          balance_customer: newBalance
        }
      })

    case types.ADD_MONEY_USER:
      currBalance = state.currentUser.balance_customer;
      newBalance = (parseFloat(currBalance) + parseFloat(action.data.price));

      return Object.assign({}, state, {
        currentUser: {
          ...state.currentUser,
          balance_customer: newBalance
        }
      })

    case types.UPDATE_CURRENT_USER_DATA:
      let userDataUpdate = Object.assign({}, state.currentUser)

      return Object.assign({}, state, {
        currentUser: {
          ...userDataUpdate,
          ...action.payload
        }
      })

    default:
      return state;
  }
}

//orderList имя может измениться

export default combineReducers({
  data,
  isLoading,
  session,
  auth,
  register,
  errorMessages,
  orderList,
  makeOrder,
  transactions,
  equipments,
  company,
  employees,
  payOutList,
  promocode,
  products,
  news,
  cameras,
  objectTypes,
  methodTypes,
  measures,
  locations,
  globalErrors,
});


// WEBPACK FOOTER //
// ./src/reducers/index.js